module.exports = __webpack_public_path__ + "img/ico-check-black.1310c681.svg";